export default __webpack_public_path__ + "assets/images/logo_2.9d5ab8.webp";